import on2next from "./on2next";

export default {
  ...on2next,
  darkmode: true,
};
